import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import {Material} from '../../../shared/classes/Material'
import { Location } from '@angular/common';
import * as moment from 'moment';
import { UploadmaterialComponent } from 'src/app/shared/components/uploadmaterial/uploadmaterial.component';
import { Observable, Subject, of } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { InwardService } from 'src/app/shared/services/inward.service';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import {InwardStatus} from 'src/app/Enums/inwardEnum';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditData, AuditMaterial, TransactionAuditTrail } from 'src/app/shared/classes/AuditTrail';
import { City } from 'src/app/shared/classes/users';
import { GraphData } from 'src/app/shared/classes/grphData';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
import { FileService } from 'src/app/shared/services/file.service';
import { UploadMaterialComponent } from '../../upload-material/upload-material.component';
import { ModalSize } from 'src/app/Enums/usersFilterEnums';

@Component({
  selector: 'app-edit-request',
  templateUrl: './edit-request.component.html',
  styleUrls: ['./edit-request.component.less']
})
export class EditRequestComponent implements OnInit {
  id: number;
  serialNumber: string;
  dcnumber: string;
  broughtFrom: string;
  remarks1: string;
  dateInputData: any = {};
  public materialList:Material[] = [];
  previousValidReturnDate: Date;
  fromtimepickervalue: Date = new Date();
  totimepickervalue: Date = new Date();
  fTime: Date = new Date;
  tTime: Date = new Date;
  fromtimevalue: any;
  totimevalue: any;
  modalRef: BsModalRef;
  data:any;
  isValidTime: boolean = true;
  transactionMasterData : any;
  ReturnSelected : Number;
  nameNotInList : string = '';
  officeData: any;
  officeName: string;
  cityName: string;
  CitySelected: string;
  recipientName: string;
  officeId: number;
  slectedOfficeID:any;
  OfficeSelected: number;
  public cityData: City [];
  MasterList:any;
  broughtFromList : [] = [];
  selectedValue?: string;
  selectedOption: any;
  showRegButton: boolean = true;
  showLoading: boolean = true;
  flag: boolean;
  isSpinning: boolean;
  public graphData: GraphData[];
  public ClientName: Array<any> = [];
  // validation Variables
  onChangeRegType : boolean = false;
  // onChangebrFrom : boolean = false;
  onChangebrFrom : boolean = true;
  recipientEmailId: string;
  InwardStatus = InwardStatus;
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();
  mstep: number = 1;
  oldResult: any;
  oldGIValues: any = [];
  newGIValues: any = [];
  oldMaterialValues: any = [];
  newMaterialValues: any = [];
  oldCopyMaterialList: any;
  newMaterialList: any;
  requestorNameChanged: boolean = false;
  travellerNameArray: any[];
  auditResult: TransactionAuditTrail = new TransactionAuditTrail();
  requestorNameDataSource: Observable<any>;
  noResultTravelerName: boolean | undefined;
  typeaheadRequestorLoading: boolean | undefined;
  EmployeeFirstName: string;
  EmployeeLastName: string;
  EmployeeAlias: string;
  selectedCityId:Array<any>=[];
  Department: string;
  debounceTimerSearchClient: any;
  attachedFilesDetails: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  attachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  @ViewChild('fromtime') fromtime: ElementRef;
  @ViewChild('totime') totime: ElementRef;
  @ViewChild('inwardregform') inwardregfrom : NgForm;
  showUploadMaterial: boolean = false;
  private initialAttachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  private deletedFileIds: number[] = [];
  constructor(
    private location: Location,
    private modalService: BsModalService,
    private _dataContextService: DataContextService,
    private httpClient : HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private loaderService: LoaderService,
    private inwardService: InwardService,
    private trackeromnitureservice:TrackerOmnitureService,private fileService: FileService) {
    this.service_URL = ConstantsService;

  }

  ngOnInit() {
    this.fileService.files$.subscribe(files => {
      if (this.attachedFiles && this.attachedFiles.length > 0) {
        const newFiles = files.filter(file => file.requestType === 'Inward');
        newFiles.forEach(newFile => {
          const exists = this.attachedFiles.some(attachedFile => attachedFile.name === newFile.name);
          if (!exists) {
            this.attachedFiles.push(newFile);
            this.attachedFilesDetails.push(newFile);
          }
        });
      } else {
        this.attachedFiles = files.filter(file => file.requestType === 'Inward');
        //this.attachedFilesDetails = [...this.attachedFiles];
      }
    });
    this.fileService.clearFiles();
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('inward-edit',username);
    this.trackeromnitureservice.trackPage("pageView");

    this.id = this.route.snapshot.params['id'];

    // console.log(this.ReturnSelected);
    this.dateInputData.EndDate = new Date();
    this.fromtimevalue = this.GetTimeForDates(new Date);
    this.totimevalue = this.GetTimeForDates(new Date);
    this.dateInputData.StartDate = new Date();
    // console.log(this.dateInputData.StartDate);
    //this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate() - 7);
    this.dateInputData.maxDate = new Date();

    this.dateInputData.maxToDate = new Date();
    this.dateInputData.maxToDate.setDate(this.dateInputData.maxToDate.getDate() + 168);

    this.dateInputData.FromMinDate = new Date();
    this.dateInputData.FromMinToDate = new Date();

    this.dateInputData.FromMinDate.setDate(this.dateInputData.StartDate.getDate() - 1095);
    this.dateInputData.FromMinDate.setDate(this.dateInputData.EndDate.getDate() - 1095);

    //Getting Transaction Master Data into Dropdowns
    this.getRequestType();
    this.getBroughtFromList();

    this.GetDetailsById(this.id);
  }

  GetDetailsById(id: number){
    this._dataContextService.get<any>(this.service_URL.InwardDetails.ViewRequest + '/' + id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.oldResult = res;
        this.oldCopyMaterialList = Object.assign({}, res.materialList);
        this.dcnumber = res.dcNumber;
        this.ReturnSelected = res.registrationType;
        this.broughtFrom = res.broughtFromName;
        this.materialList = res.materialList;
        this.cityName = res.cityName;
        this.officeName = res.officeName;
        this.CitySelected = res.cityId;
        this.recipientName = res.recipientName;
        this.recipientEmailId=res.recipientEmailId
        this.OfficeSelected = res.officeId;       
        if (res.attachedFiles && res.attachedFiles.length > 0) {
          this.attachedFiles = res.attachedFiles;
        } else {
          this.attachedFiles = [];
        }
        var len = this.materialList.length;
        for(var i=0;i<len;i++){
          this.materialList[i].Name = res.materialList[i].name;
          this.materialList[i].Quantity = res.materialList[i].quantity;
          this.materialList[i].Notes = res.materialList[i].notes;
        }

        this.dateInputData.StartDate = new Date(res.registrationDateTime);
        this.dateInputData.EndDate = new Date(res.returnDateTime);
        this.previousValidReturnDate = new Date(res.returnDateTime);
        // this.fTime = this.dateInputData.StartDate;
        // this.tTime = this.dateInputData.EndDate;
        this.fromtimepickervalue = this.dateInputData.StartDate;
        this.totimepickervalue = this.dateInputData.EndDate;
        this.fromtimevalue = this.GetTimeForDates(this.dateInputData.StartDate);
        this.totimevalue = this.GetTimeForDates(this.dateInputData.EndDate);
        this.remarks1 = res.remarks;
        this.serialNumber=res.serialNumber;
        this.showLoading = false;
        this.GetDropdownData()
      }
      )
  }

  //To load cities data 
  GetDropdownData() {

    this._dataContextService.get<any>(this.service_URL.Master.InwardMasterData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        this.MasterList = res;
        this.cityData = this.MasterList.cityList;
        this.BindOfficeDropdown(null);
      },
      (err) => {
        console.log(err);
      })
  }
  OnchangeCity(event) {
    
    if(!this.CitySelected)
    {
      var tempo : Array<any>=[];
      var temp : Array<any>=[];
      let i=0;
      for(i=0;i<this.selectedCityId.length;i++){
        tempo= this.MasterList.office.filter((item) => {
          return item.cityId === this.selectedCityId[i].cityId
        });
         temp = temp.concat(tempo);
  
      }
      this.officeData =   temp.sort((item1,item2)=>(item1.displayName < item2.displayName)?-1:1);
      
    }
    let i=0;
    var l=this.officeName.length;
    for(i=0;i<l;i++)
    {
      this.removeOfficeSelected(this.officeName[0]);
    }
 
    this.officeData = this.MasterList.officeList.filter((item) => {
      return item.cityID === this.CitySelected
      }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
    }
    removeOfficeSelected(item):void{
      this.officeName=this.MasterList.officeList.filter(x=>x.officeID!=item.officeID);
      this.officeData.push(item);
      this.officeData.sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
    }
  onselectClient(ClientObj) {

    this.recipientName = ClientObj.displayName;
    localStorage.setItem('mail', ClientObj.mail);
    this.flag = false;
    this.isSpinning = false;
    this.recipientEmailId = ClientObj.mail.toLowerCase();
  }

  searchClient(val : string) {
    clearTimeout(this.debounceTimerSearchClient);

    if (val.length > 2) {
      this.flag = true;
      this.isSpinning = true;
       let url = this.service_URL.Users.graphApi+"?key="+val;
      let data = {
        key: ""
      };

    this.debounceTimerSearchClient = setTimeout(() => {
      this._dataContextService.get<any>(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
          this.graphData = res;
          this.ClientName = this.graphData;
          this.isSpinning = false;
      },
        (err) => {
          console.log(err);
          this.isSpinning = false;
        })
      }, 300);
    }
    else {
      this.isSpinning = false;
    }
  }

  //typeheadcode
  onTravellerNameSeach() {
    this.requestorNameDataSource = Observable.create((observer: any) => {
      let txt = this.recipientName;
      let url = this.service_URL.Users.graphApi;
      let param = new HttpParams().set("key", txt);
      this._dataContextService.GetwithValues<any>(url, null, param)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(result => {
          this.travellerNameArray = result;
          observer.next(result);
        });
      this.requestorNameChanged = true;
    }).pipe(mergeMap((token: string) => this.getRequestorNamesData(token)));
  }

  getRequestorNamesData(token: string): Observable<any> {

    let query = new RegExp(token, 'ig');
    return of(
      this.travellerNameArray.filter((obj: any) => {
        let hostObj = query.test(obj.displayName)
        return obj;
      })
    );
  }
  changeRequestorTypeaheadLoading(e: boolean): void {
    if (this.requestorNameChanged != false) {
      this.typeaheadRequestorLoading = e;
    }
  }
  //On selection of particular value
  requestorNameOnSelect(e: TypeaheadMatch): void {
    this.recipientName = e.item.displayName;
  }
  typeaheadTravelerNoResults(event: boolean): void {
    this.EmployeeFirstName = undefined;
    this.EmployeeLastName = undefined;
    this.EmployeeAlias = undefined
    this.Department == undefined
    this.noResultTravelerName = event;

  }
  //Bind the office Dropdown
  BindOfficeDropdown(event) {
    this.officeData = this.MasterList.officeList.filter((item) => {
      return item.cityID === this.CitySelected;
    }).sort((item1,item2)=>(item1.officeName < item2.officeName)?-1:1);
    this.OfficeSelected= this.OfficeSelected;

  }
  
  OnchangeOffice(event: any) {
    this.slectedOfficeID=this.officeData.filter(x=>x.officeName==this.officeName);
  }

  showButton(){

    if(this.onChangebrFrom && this.broughtFrom!=='' && this.dcnumber !== '' && this.materialList.length > 0 && this.recipientName){
      // Material List Validation
      if(this.materialList.length > 0){
        var flag = false;
        for(var i=0;i<this.materialList.length;i++){
          flag = false;
          var task = this.materialList[i];
          if(task.Name == '' || task.Quantity == null || task.Quantity == 0){
            flag = true;
            break;
          }
        }
        if(flag){
          return true;
        }
      }
      return false;
    }
    return true;
  }

  fromTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.fTime).format('DD/MM/YYYY') + ', ' + this.fromtime.nativeElement.value;
    }
    this.fTime = new Date(input);
    this.fromtimevalue = this.GetTimeForDates(this.fTime);
  }

  toTimePickerValueChanges(input: any) {
    if (input == null) {
      input = moment(this.tTime).format('DD/MM/YYYY') + ', ' + this.totime.nativeElement.value;
    }
    this.tTime = new Date(input);
    this.totimevalue = this.GetTimeForDates(this.tTime);

    // Second variable with 12 hour format time as a string
    var twelveHourFormatTime = this.totimevalue;

    // Split the time into hours and minutes
    var [hourStr, minuteStr] = twelveHourFormatTime.split(':');
    var hours = parseInt(hourStr, 10);
    var minutes = parseInt(minuteStr, 10);

    // If the time is in PM, add 12 to the hours
    if (twelveHourFormatTime.includes('PM') && hours !== 12) {
      hours += 12;
    }

    // Set the hours and minutes on the current date
    this.dateInputData.EndDate.setHours(hours);
    this.dateInputData.EndDate.setMinutes(minutes);

    // console.log(this.dateInputData.EndDate);
  }

  GetTimeForDates(date: Date): string {
    let time = moment(date).format("hh:mm A");
    return time;
  }

  addMaterial(){
    this.materialList.push(new Material())
    //console.log(this.materialList)
  }

  removeMaterial(index:number){
    if(index > -1){
      this.materialList.splice(index,1);
    }
  }

  OnchangeReturnType(event){
    // console.log(event);
    // console.log(this.ReturnSelected);
    this.onChangeRegType = true;
  }

  uploadMaterial()
  {
    this.modalRef = this.modalService.show(UploadmaterialComponent)
    // console.log(this.data);
    this.modalRef.content.event.subscribe(res => {
      //  console.log(res);
    });
    // this.modalRef.afterClosed().subscribe()
  }

  isValid(event: any) {
    this.isValidTime = event;
  }

  setOldValues(oldGI: any, oldMaterialList: any){
    //Setting General Information Values
    // this.oldGIValues.serialNumber = oldGI.serialNumber;
    this.oldGIValues.dcNumber = oldGI.dcNumber;
    this.oldGIValues.requestType = oldGI.type;
    this.oldGIValues.returnDateTime = oldGI.returnDateTime;
    this.oldGIValues.broughtFromName = oldGI.broughtFromName;
    this.oldGIValues.remarks = oldGI.remarks;
    this.oldGIValues.cityName = oldGI.cityName;
    this.oldGIValues.officeName = oldGI.officeName;
    this.oldGIValues.recipientName = oldGI.recipientName;

    //Setting Old Material Values

    var oML: any = [];
    for(var i=0;i<oldMaterialList.length;i++){
      oML.push(oldMaterialList[i]);
    }
    this.oldGIValues.materials = oML;

    this.oldGIValues = Object.keys(this.oldGIValues).map(key => ({Name: key, Value: this.oldGIValues[key]}));
  }

  setNewValues(newMaterialList: any){
    //Setting General Information Values

    this.newGIValues.dcNumber = this.dcnumber;
    this.newGIValues.requestType = this.ReturnSelected == InwardStatus.Returnable ? 'Returnable' : (this.ReturnSelected == InwardStatus.InternalMovement ? 'Internal movement' : 'Non-Returnable');
    this.newGIValues.returnDateTime = this.dateInputData.EndDate.toISOString().replace('.000','');
    this.newGIValues.broughtFromName = this.broughtFrom;
    this.newGIValues.remarks = this.remarks1;
    this.newGIValues.cityName = this.cityName;
    this.newGIValues.officeName = this.officeName;
    this.newGIValues.recipientName = this.recipientName;
    //Setting Old Material Values

    var oML: any = [];
    for(var i=0;i<newMaterialList.length;i++){
      oML.push(newMaterialList[i]);
    }
    this.newGIValues.materials = oML;

    this.newGIValues = Object.keys(this.newGIValues).map(key => ({Name: key, Value: this.newGIValues[key]}));
  }

  saveToAuditTrail(){
    //Converting nested objects into array of objects
    var arr  = [],
      keys = Object.keys(this.oldCopyMaterialList);

    for(var i=0,n=keys.length;i<n;i++){
      var key  = keys[i];
      arr[key] = this.oldCopyMaterialList[key];
    }
    this.setOldValues(this.oldResult, arr);
    this.setNewValues(this.oldResult.materialList);

    let auditData: TransactionAuditTrail = new TransactionAuditTrail();
    auditData.changedBy = localStorage.getItem('email');
    auditData.actionPerformed = "Update";
    auditData.actionPerformedOn = "Inward";
    auditData.dateChanged = new Date();
    auditData.primaryKey = this.oldResult.serialNumber;

    let auditGIText: Array<AuditData> = new Array<AuditData>();

    this.oldGIValues.forEach((oldValues) => {
      this.newGIValues.forEach((newValues) => {
        if(oldValues.Name !== 'materials' && newValues.Name !== 'materials'){
          if(oldValues.Name === newValues.Name){
            if(oldValues.Value != newValues.Value){
              var obj : AuditData = new AuditData();
              obj.changedAttribute = oldValues.Name;
              obj.oldValue = oldValues.Value;
              obj.newValue = newValues.Value;
              auditGIText.push(obj);
            }
          }
        }
      })
    })

    auditData.generalInformation = auditGIText;

    let auditMaterialText: Array<AuditMaterial> = new Array<AuditMaterial>();

    arr.forEach((OM) => {
      var flag = false;
      this.oldResult.materialList.forEach((NM) => {
        if(OM.materialId == NM.materialId){
          flag = true;
            if(OM.name !== NM.Name){
            var obj: AuditMaterial = new AuditMaterial();
            obj.changedAttribute = "Name";
            obj.oldValue = OM.name;
            obj.newValue = NM.Name;
            obj.materialName = OM.name;
            auditMaterialText.push(obj);
          }
            if(OM.notes !== NM.Notes){
            var obj: AuditMaterial = new AuditMaterial();
            obj.changedAttribute = "Notes";
            obj.oldValue = OM.notes;
            obj.newValue = NM.Notes;
            obj.materialName = OM.name;
            auditMaterialText.push(obj);
          }
            if(OM.quantity != NM.Quantity){
            var obj: AuditMaterial = new AuditMaterial();
            obj.changedAttribute = "Quantity";
            obj.oldValue = OM.quantity.toString();
            obj.newValue = NM.Quantity.toString();
            obj.materialName = OM.name;
            auditMaterialText.push(obj);
          }
        }
      });
    if(!flag){
        var obj: AuditMaterial = new AuditMaterial();
        obj.changedAttribute = "Delete Material";
        obj.oldValue = OM.name;
        obj.newValue = null;
        obj.materialName = OM.name;
        auditMaterialText.push(obj);
      }
    });

    this.oldResult.materialList.forEach((NM) => {
    if(NM.MaterialId == 0){
        var obj: AuditMaterial = new AuditMaterial();
        obj.changedAttribute = "Add Material";
        obj.oldValue = null;
        obj.newValue = NM.Name;
        obj.materialName = NM.Name;
        auditMaterialText.push(obj);
      }
    });

    auditData.material = auditMaterialText;

    this.auditResult = auditData;
  }

  updateInwardRequest(dcVal,brfrom,remarks){
    // console.log(this.selectedOption);
    // console.log(brfrom.value);
    if(this.ReturnSelected != undefined){
      this.deletedFileIds.forEach(fileId => {
        let url = this.service_URL.InwardDetails.DeleteAttchedFile + '/' + fileId;
        this._dataContextService.postDatawithValuesForDel<any>(url)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(res => {
            if (res == "1") {
              this.toast.success("File marked as inactive successfully!");
            }
          });
      });
      this.saveToAuditTrail();
        let PrepareObj = {
        RequestId: this.id,
        DCNumber : this.dcnumber,
        RegistrationDateTime : this.dateInputData.StartDate.toISOString(),
        ReturnDateTime : this.ReturnSelected == InwardStatus.NonReturnable ? null : this.dateInputData.EndDate.toISOString(),
        Remarks : this.remarks1 == null ? null : this.remarks1,
        BroughtFromId : 0,
        ReceivedById : 0,
        // BroughtFromName : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
        // BroughtFrom : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
        RecipientEmailId: this.recipientEmailId,
        RecipientName: this.recipientName,
        BroughtFromName : this.broughtFrom.toUpperCase(),
        BroughtFrom : this.broughtFrom.toUpperCase(),
        ReceivedBy : '-',
        ReceivedByName : '-',
        RegistrationType : this.ReturnSelected,
        IsActive : true,
        StatusId : InwardStatus.Created,
        CityId : this.CitySelected,
        OfficeId : this.slectedOfficeID == undefined ? this.OfficeSelected : this.slectedOfficeID[0].officeID,  //this.OfficeSelected,//this.officeName !=this.OfficeSelected[0].officeName ? null:this.OfficeSelected[0].officeID,
        CreatedBy: localStorage.getItem('email'),
        UpdatedBy: localStorage.getItem('email'),
        SerialNumber: this.serialNumber,
        //attachedFiles: this.attachedFilesDetails.length > 0 ? this.attachedFilesDetails : [],
        attachedFiles: this.attachedFilesDetails && this.attachedFilesDetails.length > 0 ? this.attachedFilesDetails : this.attachedFiles,
        materialList : this.materialList
      }

      // console.log(PrepareObj);

      this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateInwardRequest, PrepareObj)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
          // this.modalRef.hide();
          this.loaderService.show();
          this.inwardService.refreshwithFilters.next();
          this.toast.success("Successfully Updated Request Details!");
        },
          (err) => {
            // console.log(err);
            this.toast.error("Something went wrong !");
          },
          () => {
            //Saving Data in Audit Trail
            let auditParams = {
              actionPerformed : this.auditResult.actionPerformed,
              actionPerformedOn : this.auditResult.actionPerformedOn,
            changedBy : this.auditResult.changedBy,
            dateChanged : this.auditResult.dateChanged,
            primaryKey : this.auditResult.primaryKey,
            generalInformation : this.auditResult.generalInformation,
            material : this.auditResult.material,
              statusChange: []
            };

          this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((res) => {
                // console.log(res);
                this.location.back();
              },
                (err) => {
                  console.log(err);
                })
          });
    }
    else{
      this.toast.error("Please add the missing details !");
    }
  }

  GetData(){
    // console.log(this.materialList);
  }

  goBack() : void{
    this.location.back();
  }

  onSelect(event: TypeaheadMatch): void {
    this.selectedOption = event.item;
    // console.log(this.selectedOption);
    // console.log(this.selectedValue);
  }

  onChangename(event){
    this.nameNotInList = event;
    this.onChangebrFrom = true;
  }

  getBroughtFromList(){
    this._dataContextService.get<any>(this.service_URL.InwardDetails.BroughtFrom)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
        // console.log(res);
        this.broughtFromList = res;
      })
  }

  getRequestType(){
    this._dataContextService.get<any>(this.service_URL.OperationsMasterData.GetTransactionData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => {
      this.transactionMasterData = res.filter((item)=>
      {  
          return item.category == 'inwardrequesttype'
        });
        // console.log(this.transactionMasterData);
      })
  }

  // Validate return date to prevent past dates and preserve original date on failure
  validateReturnDate(selectedDate: Date): void {
    if (!selectedDate || !this.dateInputData.StartDate) return;
    
    // Initialize previousValidReturnDate if not set
    if (!this.previousValidReturnDate) {
      this.previousValidReturnDate = new Date(this.dateInputData.StartDate);
    }
    
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0);
    
    // Return date minimum should be the registration date (not today)
    const registrationDate = new Date(this.dateInputData.StartDate);
    registrationDate.setHours(0, 0, 0, 0);
    
    const maxDate = new Date(this.dateInputData.maxToDate);
    maxDate.setHours(0, 0, 0, 0);
    
    if (selected < registrationDate) {
      this.toast.error('Return date cannot be before the registration date');
      // Reset to previous valid date (e.g., if was 13, reset back to 13)
      this.dateInputData.EndDate = new Date(this.previousValidReturnDate);
    } else if (selected > maxDate) {
      this.toast.error('Return date cannot be more than 168 days from the registration date');
      // Reset to previous valid date
      this.dateInputData.EndDate = new Date(this.previousValidReturnDate);
    } else {
      // Validation passed, update the stored valid date
      this.previousValidReturnDate = new Date(selectedDate);
    }
  }

  increase(num: any){
    this.materialList[num].Quantity++;
  }

  decrease(num: any){
    if(this.materialList[num].Quantity != 0){
      this.materialList[num].Quantity--;
    }
  }
  deleteFile(index: number): void {
    if (this.attachedFiles && this.attachedFiles.length > 0) {
      const fileId = this.attachedFiles[index].fileId;
      if (fileId !== null && fileId !== undefined) {
        this.deletedFileIds.push(fileId);
        this.attachedFiles.splice(index, 1);
    } 
  else {
   const fileName = this.attachedFiles[index].name;
 
   const subscription = this.fileService.files$.subscribe(files => {
    const fileIndex = files.findIndex(x => x.name === fileName);
    if (fileIndex !== -1) {
      this.fileService.removeFile(fileIndex);
      this.attachedFiles.splice(index, 1);
      // Remove the file from attachedFilesDetails using fileId
      const attachedFileIndex = this.attachedFilesDetails.findIndex(file => file.name === fileName);
      if (attachedFileIndex !== -1) {
        this.attachedFilesDetails.splice(attachedFileIndex, 1);
      }
    }
    subscription.unsubscribe(); // Unsubscribe after use
  });
}

}
  }
  UploadMaterial(){
       
    this.modalRef = this.modalService.show(UploadMaterialComponent,{
      initialState : {
        requestType: 'Inward' 
      }
    })
    this.modalRef.setClass(ModalSize.Large);
    this.modalRef.content.event.subscribe(res => {
      console.log(res);
    });
  }
  closeUploadMaterial(): void {
    this.showUploadMaterial = false;
   
  }
  handleFileData(fileData: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string }): void {
    this.attachedFiles.push(fileData);
    this.fileService.updateFiles(this.attachedFiles);
  }
}
